// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"176":"projects","289":"tos","296":"privacy"}[chunkId] + "." + {"176":"801fc8db","289":"043da0fc","296":"8cb97ab0"}[chunkId] + ".js";
};